import { getTimepointExamReassignmentCheckStudiesStudyIdSubjectsSubjectIdTimepointSubmissionTimepointSubmissionIdExamReassignCheckGet } from '@common/config/api/client'
import { useQuery } from '@tanstack/react-query'

export const useTimepointExamReassignementCheck = (
  queryKey: string[],
  studyId: string | undefined,
  subjectId: string | undefined,
  timepointSubmissionId: string | undefined,
  exam_metadata_ids?: string[],
) => {
  return useQuery({
    queryKey: [...queryKey, studyId, subjectId, timepointSubmissionId, exam_metadata_ids],
    queryFn: () =>
      getTimepointExamReassignmentCheckStudiesStudyIdSubjectsSubjectIdTimepointSubmissionTimepointSubmissionIdExamReassignCheckGet(
        {
          path: { study_id: studyId!, subject_id: subjectId!, timepoint_submission_id: timepointSubmissionId! },
          query: {
            exam_metadata_ids: exam_metadata_ids,
          },
        },
      ),
    enabled: !!studyId && !!subjectId && !!timepointSubmissionId,
  })
}
